import { Chip, Label } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { ClearChipProps as Props } from './types';

export const ClearChip = memo(({ className, onClick, text, count }: Props) => {
  return (
    <Chip
      className={classnames('ClearChip', className)}
      sx={SX.root}
      size="small"
      variant="outlined"
      color="default"
      label={
        <Box display={'flex'} alignItems={'center'} gap={0.5} lineHeight={2}>
          {text ?? 'Clear'}
          {!!count && (
            <Label size="xxxsmall" color="primary" variant="filled">
              {count}
            </Label>
          )}
        </Box>
      }
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    />
  );
});

ClearChip.displayName = 'ClearChip';
